export enum ContentType {
    Title,
    Description,
    Image,
    Card,
}

export enum SectionType {
    Main,
    WhatWeDo,
    WhoWeSupport,
    Team,
    People,
}
